export enum ActivityPropertyDataType {
  STRING,
  BOOLEAN,
  INTEGER,
  ACTOR_TYPE,
  DELETE_RESOURCES_TARGET_TYPE,
  LOG_ON_TYPE,
  POWER_SHELL_INPUT_TYPE,
  POWER_SHELL_RETURN_TYPE,
  POWER_SHELL_SCRIPT_LOCATION,
  DEFINITION_TABLE,
  STRING_ARRAY,
  HTMLSTRING,
  IDGENERATOR_TYPE,
}
